import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';

/**
 * Index Route (/)
 * 
 * Redirects to the dashboard for authenticated users
 * or to login for unauthenticated users
 */

export const Route = createFileRoute('/')({
  component: IndexComponent,
});

function IndexComponent() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // Redirect based on authentication status
  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="/login" />;
}
